import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import { observable } from 'rxjs';
import { GlobalConstants } from '../global-constants';
import { SplashScreenStateService } from '../services/splash-screen-state-service';
@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.css']
})
export class PhotosComponent implements OnInit {
  public currentCount = 0;
  public item1 = '';
  public item2 = '';
  public theHtmlString ="";
  public photosPath = GlobalConstants.photosServerPath; 
  retFolders: Array<string>;
  retFiles: Array<any> = [];
  retItem: any;
  fileObject: Object;
  constructor(private genericService: GenericService,private splashScreenStateService: SplashScreenStateService)  { 


  }

  ngOnInit() {
    setTimeout(() => {
      this.splashScreenStateService.stop();
      
   }, 1500);


//this.LoadData();
this.LoadData2();



  }

  LoadData2() {
    let data =["test.jpg"

  ]
  
  // let test =  {
  //   album: '',
  //   file: ''
  // };
  // this.fileObject = test;
  
  
  
  this.retFolders = ["AutoPlant", "MuralDetroit", "Sunsets"];
  
  let i1 =  {
  album: "AutoPlant",
  file: "a.jpg"
  };
  
  // test.album = "AutoPlant";
  // test.file = "AutoPlant/"+ data[0];
  
  // var a = new Object;
  // a = test;
  this.retFiles.push(i1);
  //test = null;
  let i2 =  {
  album: "MuralDetroit",
  file: "IMG_20141228_135752_637.jpg"
  };
  
  
  this.retFiles.push(i2);
  
  let i3 =  {
  
  album: "Sunsets",
  file: "2012-08-01_19-58-40_362.jpg"
  };
  
  this.retFiles.push(i3);


  setTimeout(() => {
    this.splashScreenStateService.stop();
    
 }, 1000);



 
  // setTimeout(function(){
  //   // Code to run after the pause
  //   alert("This is really slow!");
  //   this.splashScreenStateService.stop();
  // }, 3000);


  }

  LoadData() {
    
        this.genericService.getFilesByDirectory(224).subscribe((data) => {

 
          

        let test =  {
            album: '',
            file: ''
        };
this.fileObject = test;



this.retFolders = ["AutoPlant", "MuralDetroit", "Sunsets"];

let i1 =  {
  album: "AutoPlant",
  file: "AutoPlant/"+ data[0]
};

// test.album = "AutoPlant";
// test.file = "AutoPlant/"+ data[0];

// var a = new Object;
// a = test;
this.retFiles.push(i1);
//test = null;
let i2 =  {
  album: "MuralDetroit",
  file: "MuralDetroit/"+ data[1]
};


this.retFiles.push(i2);

let i3 =  {

  album: "Sunsets",
  file: "Sunsets/"+ data[2]
};

this.retFiles.push(i3);





// this.retFiles.push(new {"album":"AutoPlant", "file": "AutoPlant/"+ data[0]}   );
//  this.retFiles.push("MuralDetroit/"+ data[1]);
//  this.retFiles.push("Sunsets/"+ data[2]);

// for (var val of data) {

// this.retFiles.push()
//   console.log(val); // prints values: 10, 20, 30, 40
// }
          this.retItem = data;
          console.log(this.retItem);
       //   if (this.retItem.length > 0) {
          //  this.currentCount = this.retItem.length;
          //   this.item1 = this.retItem.name;
          //   this.item2 = this.retItem.name_sub;
          //   this.theHtmlString = this.retItem.html_content;
          //  alert("data here");
          //   this.dataavailbale = true;
          // }
          // else {
          //   this.dataavailbale = false;
       //   }
    
    
        }
        )
          , err => {
            console.log(err);
          }
      }

}
